import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Link, VStack } from '@chakra-ui/react'

export const Sidebar = () => (
  <VStack padding={2} width='250px' borderRightWidth='1px'>
    <Link as={RouterLink} to='/admin/relatorios'>
      Relatórios
    </Link>
    <Link as={RouterLink} to='/admin/questionarios'>
      Questionários
    </Link>
    <Link as={RouterLink} to='/admin/questoes'>
      Questões
    </Link>
    <Link as={RouterLink} to='/admin/dimensoes'>
      Dimensões
    </Link>
    <Link as={RouterLink} to='/admin/config'>
      Configurações
    </Link>
  </VStack>
)

export default Sidebar
